import React from 'react';
import { Badge, Button } from '@/components/ui';

interface ContractZonesMobileListProps {
  zones: any[];
  isLoading?: boolean;
  onDelete?: (assignmentId: string) => void;
}

const difficultyColors: Record<string, string> = {
  easy: 'bg-emerald-50 text-emerald-600 border-emerald-100',
  medium: 'bg-amber-50 text-amber-600 border-amber-100',
  hard: 'bg-red-50 text-red-600 border-red-100',
};

export function ContractZonesMobileList({ zones, isLoading, onDelete }: ContractZonesMobileListProps) {
  if (isLoading) return <div className="p-6 text-center text-slate-500">Đang tải...</div>;
  if (!zones.length) return <div className="p-12 text-center text-slate-400">Chưa có khu vực nào</div>;

  return (
    <div className="divide-y divide-slate-50">
      {zones.map((item) => (
        <div key={item.id} className="p-4 space-y-3">
          <div className="flex justify-between items-start">
            <div>
              <span className="text-[10px] font-bold text-slate-400  tracking-wider block">
                {item.zone?.zone_code}
              </span>
              <h4 className="font-bold text-slate-900">{item.zone?.zone_name}</h4>
            </div>
            <Badge
              variant="outline"
              className={`text-[9px] font-bold  ${difficultyColors[item.difficulty_level] || 'bg-slate-50 text-slate-600'}`}
            >
              {item.difficulty_level}
            </Badge>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-[10px] text-slate-400  font-bold">Diện tích</p>
              <p className="text-sm font-bold text-slate-700">
                {(item.area_m2 || item.zone?.area_m2)?.toLocaleString() || '-'} m²
              </p>
            </div>
            <div>
              <p className="text-[10px] text-slate-400  font-bold">Tần suất</p>
              <p className="text-sm font-bold text-slate-700 capitalize">{item.visit_frequency}</p>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button variant="ghost" size="sm" icon="ri-settings-4-line" className="h-8 px-2 text-xs">Sửa</Button>
            <Button
              variant="ghost"
              size="sm"
              icon="ri-delete-bin-line"
              className="h-8 px-2 text-xs text-red-500"
              onClick={() => onDelete?.(item.id)}
            >
              Gỡ
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
